import { IconSvgProps } from "../types";

export const Cross = ({ size, style, color, ...props }: IconSvgProps) => (
    <svg
        id="icon-basic-cross"
        // eslint-disable-next-line local/ensure-wac-token-usage
        style={{ color: color ?? "#7a869a", ...style }}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <path
            d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z"
            fill="currentColor"
        />
    </svg>
);
